import React, { useEffect, useState } from 'react';

import { SelectTW } from 'components/opsVisibility/components/inventoryHistoryV2/filterComponentTailwind/SelectTW';

import '../filterComponents.css';

function SelectFilterTW({
    currentValue,
    deletable,
    filterKey,
    label,
    loading = false,
    multiple = false,
    onFilterChange,
    options = [],
    placeholder = 'Select...',
    searchable = false,
    type,
}) {
    // Convert options from strings to {value, label} format
    const formattedOptions = options.map((opt) => ({
        value: opt,
        label: opt,
    }));

    // Extract values from filter format
    const getValue = () => {
        if (!currentValue) return null;

        if (multiple) {
            return Array.isArray(currentValue) ? currentValue.map((v) => v.data) : [];
        }
        return currentValue.data;
    };

    // Handle change and format for the filter system
    const handleChange = (value) => {
        if (value === null) {
            onFilterChange(null);
            return;
        }

        if (multiple) {
            onFilterChange(
                value.map((val) => ({
                    type,
                    data: val,
                    chipLabel: `${label}: ${val}`,
                    filterKey,
                    deletable,
                })),
            );
        } else {
            onFilterChange({
                type,
                data: value,
                chipLabel: `${label}: ${value}`,
                filterKey,
                deletable,
            });
        }
    };

    return (
        <SelectTW
            options={formattedOptions}
            value={getValue()}
            onChange={handleChange}
            placeholder={placeholder}
            multiple={multiple}
            loading={loading}
            searchable={searchable}
        />
    );
}

export { SelectFilterTW };
